import { GET, POST, newFetch } from "./fetch";
import { config } from "../config/index";
const { SSO_URL, APP_ID } = config;

/**
 * General Functions
 */
const getSSOAuthToken = async (email) => {
  try {
    let api_path = `${SSO_URL}/auth/token`;
    let response = await newFetch(
      POST,
      api_path,
      {
        app_id: APP_ID,
        email: email,
      },
      "json",
      "json",
      true
    );

    return response.status ? response.token : false;
  } catch (error) {
    console.log("error", error);
  }
};

const getSSOAuthDetailsByToken = async (token) => {
  try {
    const url = `${SSO_URL}/details/${APP_ID}`;
    const response = await fetch(url, {
      method: GET,
      withCredentials: true,
      mode: "cors",
      headers: {
        Authorization: token,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json; charset=utf-8",
      },
    });

    const json = await response.json();

    return response.ok ? json : false;
  } catch (error) {
    console.log("error", error);
  }
};

const getRefreshToken = async (token) => {
  try {
    const url = `${SSO_URL}/refresh/token`;
    const response = await fetch(url, {
      method: GET,
      withCredentials: true,
      mode: "cors",
      headers: {
        authorization: token,
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json; charset=utf-8",
      },
    });

    const json = await response.json();

    return response.ok ? json : false;
  } catch (error) {
    console.log("error", error);
  }
};

export { getSSOAuthToken, getSSOAuthDetailsByToken, getRefreshToken };
